const transformData = [
    {
        name: '0 - 5 %',
        value: 'JOBS _DWT_T1_5'
    },
    {
        name: '6 - 25%',
        value: 'JOBS _DWT_T1_25'
    },
    {
        name: '26 - 50%',
        value: 'JOBS _DWT_T1_50'
    },
    {
        name: '51 - 75%',
        value: 'JOBS _DWT_T1_75'
    },
    {
        name: '76 - 100%',
        value: 'JOBS _DWT_T1_100'
    },
];

/**
 * Survey: PROJECT- FINAL IMPACT
 * Question: In your estimation, how much your participation in the program contributed to these results?
 * 
 * == final
 * jobs_dwt_t1
 * 
 * @param props 
 * @returns 
 */
export const e4ImpactContributionToResultsChartCalculation = (props: any) => {
    const data = transformData.map(({name, value}) => ({
        name,
        y: props.finalSubmissions.filter((s: any) => s.jobs_dwt_t1 === value).length
    }));

    return {
        chart: {
            type: 'column',
        },
        title: {
            text: 'KPI: E4Impact contribution to results',
            align: 'left',
        },
        yAxis: {
            min: 0,
            title: {
                text: '',
            },
        },
        xAxis: {
            categories: transformData.map((el) => el.name),
        },
        plotOptions: {
            column: {
                pointPadding: 0.2,
                borderWidth: 0,
            },
        },
        series: [
            {
                showInLegend: false,
                name: 'Number',
                data,
                type: 'column',
            },
        ],
    } as Highcharts.Options;
}